import React, { Component } from "react";
import { Link } from "react-router-dom";
import Social from "../section-components/social";
import Copyright from "./copyright";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import CookieConsent from "./CookieConsent";

class Footer_v1 extends Component {
  componentDidMount() {
    const $ = window.$;

    let publicUrl = process.env.PUBLIC_URL + "/";
    const minscript = document.createElement("script");
    minscript.async = true;
    minscript.src = publicUrl + "assets/js/main.js";

    document.body.appendChild(minscript);

    $(".go-top")
      .find("a")
      .on("click", function () {
        $(".quarter-overlay").fadeIn(1);

        $(window).scrollTop(0);

        setTimeout(function () {
          $(".quarter-overlay").fadeOut(300);
        }, 800);
      });

    $(document).on("click", ".theme-btn-1 ", function () {
      $("div").removeClass("modal-backdrop");
      $("div").removeClass("show");
      $("div").removeClass("fade");
      $("body").attr("style", "");
    });
  }

  render() {
    const { settings, category, loading, lang, pageConfig } =
      this.props.appData;
    const footerInfosConfig = pageConfig?.footer?.settings?.infos ?? [];
    const categories = Array.isArray(category?.categories)
      ? category.categories
      : [];
    const isTr = lang === "tr";
    return (
      <footer className="ltn__footer-area  ">
        <div className="footer-top-area  section-bg-2 plr--5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-about-widget">
                  <div className="footer-logo">
                    <div className="site-logo">
                      {!loading && settings?.footerLogo && (
                        <img
                          src={API_FILE_URL + settings.footerLogo}
                          alt="Footer Logo"
                        />
                      )}
                    </div>
                  </div>
                  <div className="footer-address">
                    <ul>
                      {footerInfosConfig.map((info, index) => (
                        <li key={index}>
                          <div className="footer-address-icon">
                            <i className={info.icon} />
                          </div>
                          <div className="footer-address-info">
                            <p>{info.info}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="ltn__social-media mt-20">
                    <Social />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">
                    {isTr ? "Kurumsal" : "Corporate"}
                  </h4>
                  <div className="footer-menu go-top">
                    <ul>
                      <li>
                        <Link to="/kurumsal">
                          {isTr ? "Hakkımızda" : "About Us"}
                        </Link>
                      </li>
                      <li>
                        <Link to="/kurumsal#tarihce">
                          {isTr ? "Tarihçe" : "Our History"}
                        </Link>
                      </li>
                      <li>
                        <Link to="/kurumsal#arge">{isTr ? "AR-GE" : "R&D"}</Link>
                      </li>
                      <li>
                        <Link to="/kurumsal#sertifikalar">
                          {isTr ? "Sertifikalar" : "Certificates"}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">
                    {isTr ? "Kategoriler" : "Categories"}
                  </h4>
                  <div className="footer-menu go-top">
                    <ul>
                      {categories.map((cat, i) => {
                        const t = cat.translations?.[lang] || {};
                        return (
                          <li key={i}>
                            <Link
                              to={{
                                pathname: "/urunler",
                                state: { categoryId: cat.id },
                              }}
                            >
                              {t?.name || ""}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">
                    {isTr ? "Satış & Servis" : "Sales & Service"}
                  </h4>
                  <div className="footer-menu go-top">
                    <ul>
                      <li>
                        <Link to="/satis-servis">
                          {isTr ? "Satış Noktaları" : "Sales Locations"}
                        </Link>
                      </li>
                      <li>
                        <Link to="/satis-servis">
                          {isTr ? "Servis Merkezleri" : "Service Centers"}
                        </Link>
                      </li>
                      <li>
                        <Link to="/yatirimci-iliskileri">
                          {isTr ? "Yatırımcı İlişkileri" : "Investor Relations"}
                        </Link>
                      </li>
                      <li>
                        <Link to="/iletisim">
                          {isTr ? "İletişim" : "Contact"}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Copyright isTr={isTr} />
        <CookieConsent lang={lang} />
      </footer>
    );
  }
}

export default withAppData(Footer_v1);
